import { useQuery } from "react-query";
import axios from "infra/http";

function useAreasComumSimples(
  tenantId: string | null,
  params?: { search?: string }
) {
  return useQuery(
    `/v1/tenants/${tenantId}/area-comum/simples?search=${params?.search}`,
    async () => {
      const { data } = await axios.get<{ id: string; nome: string }[]>(
        `/v1/tenants/${tenantId}/area-comum/simples`,
        {
          params,
        }
      );

      return data;
    }
  );
}

export default useAreasComumSimples;
